import { useEffect } from 'react';
import { loadSpeechStreamScript } from 'services/SpeechStreamService/speechstream';

const SpeechStream = () => {
  useEffect(() => {
    loadSpeechStreamScript().then();
  }, []);

  return null;
};

export default SpeechStream;
